export default function TemplateRowSkeleton({ count, fullWidth, sklettenMargen, sklettenPading }) {
   return Array(count)
      .fill()
      .map((o, index) => (
         <div
            key={index}
            style={{ width: fullWidth }}
            className={`loading-shade-list demo-view mt-${sklettenMargen} pt-${sklettenPading}`}
         />
      ));
}
